<template>
  <div class="container is-clipped">
    <div class="column is-full">
      <upload folder="my-stuff" />
    </div>
    <div class="columns">
      <div class="column dashboard-chart-container">
        <div class="card">
          <div class="card-content">
            <chart
              id="visits"
              :height="chartHeight"
              type="line"
              title="Visits"
              :labels="visitsChart.labels"
              :data="visitsChart.data"
              :options="visitsChart.options"
              :backgroundColor="visitsChart.backgroundColor"
            ></chart>
            <p class="has-text-right">
              <small class="has-text-grey">
                From the past 7 days
              </small>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Uploaded documents -->
    <div class="columns">
      <div class="column is-one-third dashboard-chart-container">
        <div class="card">
          <div class="card-content">
            <h6 class="title is-6">Recently Visited Documents</h6>
            <div class="table-container">
              <table class="table is-fullwidth is-striped">
                <thead>
                  <tr>
                    <th>Document</th>
                    <th>Visits</th>
                  </tr>
                </thead>
                <tbody v-if="documents.length">
                  <tr v-for="doc in documents" :key="doc._id">
                    <td class="is-ellipsis" :data-tooltip="doc.name">
                      <router-link
                        :to="{
                          name: 'documentDetail',
                          params: { id: doc._id, tab: 'visits' }
                        }"
                        :title="doc.name"
                      >
                        {{ doc.name }}
                      </router-link>
                    </td>
                    <td>
                      {{ doc.visits }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td>N/A</td>
                    <td>--</td>
                  </tr>
                </tbody>
              </table>
              <p class="has-text-right">
                <small class="has-text-grey">
                  From the past 7 days
                </small>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- There is data for the documents -->
      <div class="column is-two-thirds">
        <div class="card">
          <div class="card-content">
            <h6 class="title is-6">Recent Leads</h6>
            <div class="table-container">
              <table class="table is-striped is-fullwidth is-hoverable">
                <thead>
                  <tr>
                    <th>Document</th>
                    <th class="is-hidden-mobile">Lead</th>
                    <th class="is-hidden-mobile">Date</th>
                    <th class="is-hidden-mobile">
                      <span class="icon">
                        <i class="fas fa-download"></i>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody v-if="visits.length">
                  <tr v-for="(record, index) in visits" :key="index">
                    <td class="is-ellipsis">
                      <p class="is-hidden-tablet">
                        <strong class="mr-2">Lead</strong>
                        {{ record.visit.email || 'N/A' }}
                      </p>
                      <router-link
                        :to="{
                          name: 'documentDetail',
                          params: { id: record.link.documentId, tab: 'visits' }
                        }"
                        :title="record.link.document"
                      >
                        <!-- {{ truncateString(record.link.document) }} -->
                        {{ record.link.document }}
                      </router-link>
                      <p class="is-hidden-tablet has-text-grey">
                        <small>
                          <strong class="has-text-grey mr-2">Visited</strong>
                          {{ $moment(record.visit.date).fromNow() || `--` }}
                        </small>
                      </p>
                      <p class="is-hidden-tablet has-text-grey">
                        <small>
                          <strong class="has-text-grey mr-2">Downloaded</strong>
                        </small>
                        <span class="icon">
                          <i
                            v-if="record.visit.downloaded"
                            class="fas fa-check has-text-success"
                          ></i>
                          <i v-else class="fas fa-times has-text-danger"></i>
                        </span>
                      </p>
                    </td>
                    <td class="is-ellipsis is-hidden-mobile">
                      {{ record.visit.email || 'N/A' }}
                    </td>
                    <td class="is-hidden-mobile">
                      {{ $moment(record.visit.date).fromNow() }}
                    </td>
                    <td class="is-hidden-mobile">
                      <span class="icon">
                        <i
                          v-if="record.visit.downloaded"
                          class="fas fa-check has-text-success"
                        ></i>
                        <i v-else class="fas fa-times has-text-danger"></i>
                      </span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td>N/A</td>
                    <td>--</td>
                    <td>--</td>
                    <td>--</td>
                  </tr>
                </tbody>
              </table>
              <p class="has-text-right">
                <small class="has-text-grey">
                  Most recent leads
                </small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { truncateString } from '@/utils/general';

export default {
  name: 'Dashboard',
  components: {
    Chart: () => import('@/components/Chart'),
    Upload: () => import('@/components/UploadComponent')
  },
  data() {
    var colors = [
      `rgba(144, 190, 109, 0.6)`,
      `rgba(243, 114, 44, 0.6)`,
      `rgba(39, 125, 161, 0.6)`,
      `rgba(248, 150, 30, 0.6)`,
      `rgba(87, 117, 144, 0.6)`,
      `rgba(249, 132, 74, 0.6)`,
      `rgba(77, 144, 142, 0.6)`,
      `rgba(249, 199, 79, 0.6)`,
      `rgba(67, 170, 139, 0.6)`,
      `rgba(249, 65, 68, 0.6)`
    ];
    var hoverColors = [
      `rgba(144, 190, 109, 0.4)`,
      `rgba(243, 114, 44, 0.4)`,
      `rgba(39, 125, 161, 0.4)`,
      `rgba(248, 150, 30, 0.4)`,
      `rgba(87, 117, 144, 0.4)`,
      `rgba(249, 132, 74, 0.4)`,
      `rgba(77, 144, 142, 0.4)`,
      `rgba(249, 199, 79, 0.4)`,
      `rgba(67, 170, 139, 0.4)`,
      `rgba(249, 65, 68, 0.4)`
    ];

    return {
      colors,
      hoverColors,
      finished: false,
      links: [],
      documents: [],
      visits: [],
      labels: [],
      axis: [],
      chartData: {
        labels: [],
        type: 'polarArea',
        backgroundColor: colors,
        hoverBackgroundColor: hoverColors,
        data: [],
        options: {
          responsive: true,
          scale: {
            ticks: {
              min: 0,
              beginAtZero: true,
              stepSize: 1
            }
          }
        }
      },
      visitsChart: {
        labels: [],
        backgroundColor: colors,
        hoverBackgroundColor: hoverColors,
        data: [],
        options: {
          responsive: true,
          scales: {
            yAxes: [
              {
                ticks: {
                  min: 0,
                  beginAtZero: true,
                  stepSize: 1
                }
              }
            ]
          },
          legend: {
            display: true
          },
          title: {
            display: true,
            text: 'Total Visits'
          },
          elements: {
            line: {
              tension: 0,
              fill: false,
              borderColor: colors[0]
            }
          }
        }
      },
      truncateString: truncateString
    };
  },
  async created() {
    // this.$axios.get(this.$API.documents + 'dashboard/info').then(res => {
    //   this.documents = res.data.chartResponse;
    //   this.links = res.data.linksResponse.map(element => {
    //     return {
    //       documentId: element.document,
    //       name: element.link,
    //       lastVisit: this.$moment(element.lastVisit).fromNow(),
    //       visits: element.visits
    //     };
    //   });
    //   this.chartData.labels = res.data.chartResponse.map(element =>
    //     this.truncateString(element.document)
    //   );
    //   this.chartData.data = res.data.chartResponse.map(
    //     element => element.visits
    //   );
    //   this.visits = res.data.visitsResponse;
    //   this.finished = true;
    // });

    try {
      // Get recent leads
      this.$axios
        .get(this.$API.recentLeads(), {
          params: { limit: 5, hasTeam: this.hasTeam }
        })
        .then(response => {
          if (response.status !== 200) {
            throw new Error(`Rquest failed with status ${response.status}`);
          }
          this.visits = response.data.visits;
        })
        .catch(ex => {
          throw ex;
        });
      // Get all documents
      this.$axios
        .get(this.$API.visitCount(), {
          params: { range: 7, hasTeam: this.hasTeam }
        })
        .then(response => {
          if (response.status !== 200) {
            throw new Error(`Rquest failed with status ${response.status}`);
          }
          const privateVisits = response.data.privateVisits;
          const teamVisits = response.data.teamVisits;
          this.visitsChart.labels = privateVisits.map(v =>
            this.$moment(v.date).format('MMM DD')
          );
          this.visitsChart.data = {
            datasets: [
              {
                label: 'My Stats',
                data: privateVisits.map(v => v.count),
                borderColor: this.colors[0]
              },
              {
                label: 'Team Stats',
                data: teamVisits.map(v => v.count),
                borderColor: this.colors[1]
              }
            ]
          };
        })
        .catch(ex => {
          throw ex;
        });
      // Get recent document visits
      this.$axios
        .get(this.$API.recentDocumentVisits(), {
          params: { range: 7, hasTeam: this.hasTeam }
        })
        .then(response => {
          if (response.status !== 200) {
            throw new Error(`Rquest failed with status ${response.status}`);
          }
          this.documents = response.data;
        })
        .catch(ex => {
          throw ex;
        });
    } catch (ex) {
      console.error(ex);
    }
  },
  computed: {
    hasTeam() {
      let accessLevel = this.$store.getters['auth/getAccessLevel'];
      // Only if the current plan allows for more than 1 users.
      return parseInt(accessLevel?.users?.value, 10) > 1 || false;
    },
    hasDocuments() {
      return this.documents.length > 0;
      // return true;
    },
    hasVisits() {
      return this.visits.length > 0;
    },
    showChart() {
      return this.chartData.data.find(el => el > 0) ? true : false;
    },
    chartHeight() {
      let h = 100;
      if (window.innerWidth <= 768) {
        h = 250;
      }
      return h;
    }
  }
};
</script>
<style lang="scss" scoped>
.table {
  margin-top: 25px;
}
h1 {
  font-weight: bold;
  text-align: center;
}
</style>
